function setBodyPadding(){
    var width = $(".sidebar-v2").outerWidth()+"px";
    $(".v2").css({"padding-left": width});
}

$(document).ready(function() {
    //setBodyPadding();
});

$(".burger-container").click(function() {
    if($(".icon-title:visible").length){
        $(".sidebar-v2 .icon-title").hide();
        $(".sidebar-v2").addClass("closed");
    } else {
        $(".sidebar-v2 .icon-title").show();
        $(".sidebar-v2").removeClass("closed");
    }
});
